import deepMerge from '@/functions/deep_merge';

export const language = navigator.language.split('-')[0];
const modules = import.meta.glob('../../../config/locales/**/*.yml');
export const getTranslations = async () => {
  let locales = {};
  for (const path in modules) {
    locales = deepMerge(locales, (await modules[path]()).default);
  }
  return locales;
};
